import { memo } from 'react'
import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'
import { useTranslation } from 'react-i18next'

import { COLOR_SUCCESS } from '../../../constants/theme'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'
import Popup from '../../shared/popup/Popup'
import StatusUpgradeItem from '../../shared/purchaseStatus/StatusUpgradeItem'

const PurchaseStatusSuccess = ({ onSubmit, onCancel, tier: { id, name } }) => {
  const { t } = useTranslation()
  return (
    <Popup
      title={t('membership.purchase-status-success')}
      description={t('membership.purchase-status-success-desc')}
      icon={faCheckCircle}
      color={COLOR_SUCCESS}
      onFormSubmit={onSubmit}
      onCancel={onCancel}
      submitLabel={t('common.awesome')}
    >
      <StatusUpgradeItem
        t={t}
        label='membership.your-new-status'
        id={id}
        name={name}
      />
      <>
        <AnimateRewards />
      </>
    </Popup>
  )
}

export default memo(PurchaseStatusSuccess)
